var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"thankyoupage"}},[_c('br'),_c('br'),_c('h2',[_vm._v("Thank you for your submission!")]),_c('br'),_c('p',[_vm._v("We will get back to you soon.")])])
}]

export { render, staticRenderFns }